import React, { useCallback } from 'react'

import { useTranslation } from 'react-i18next'
import { ContentStateProperty, FieldProps } from '../../../../../../../@types/types'
import { SCREEN_OTHER_FACILITIES, SCREENS } from '../../../../../../../services/domain/wizardScreens'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import ToggleSwitch from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'

const screen = SCREENS[SCREEN_OTHER_FACILITIES]

const IntermediateRent: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  doReset,
}) => {
  const { t } = useTranslation()

  const intermediateRentChanged = useCallback(
    (property: ContentStateProperty, value: boolean) => {
      doReset?.([{ screen: screen.name, property: 'freeUntil' }])
      onChange({ screen: screen.name, property }, value)
    },
    [doReset, onChange]
  )
  return (
    <div className='grid-item one-whole'>
      <ToggleSwitch
        id='intermediate-rent'
        alignment='right'
        propertyName='intermediateRent'
        label={
          <span className={'font-body-medium-bold'}>
            {t('wizard.screen.otherFacilities.intermediateRent', 'Intermediate rent')}
          </span>
        }
        value={insertionData.intermediateRent ?? true}
        onChange={intermediateRentChanged}
      />
    </div>
  )
}

export default IntermediateRent
